import { forwardRef, type ComponentPropsWithRef } from "react";

import { cn, Radio, Typography } from "@eisox/design-system";

interface RoomProps extends ComponentPropsWithRef<"button"> {
  name: string;
  planName: string;
  selected?: boolean;
  multiple?: boolean;
}

const Room = forwardRef<HTMLButtonElement, RoomProps>(
  ({ name, planName, selected = false, multiple = false, className, ...props }, forwardedRef) => (
    <button
      {...props}
      ref={forwardedRef}
      className={cn(
        "min-w-0 flex cursor-pointer items-center gap-x-[5px] rounded-[10px] p-[10px] text-base hover:bg-primary-gray",
        selected && "text-primary-blue",
        className,
      )}
    >
      {multiple && <Radio multiple checked={selected} />}
      <Typography>{name}</Typography>
      <span className="font-light text-sm whitespace-nowrap text-primary-dark-gray italic">{planName}</span>
    </button>
  ),
);

Room.displayName = "Room";

export { Room };
export type { RoomProps };
